// src/utils/localStorage.ts
/**
 * window.localStorage 浏览器永久缓存
 */
export function set(key, val) {
    window.localStorage.setItem(key, JSON.stringify(val));
}
// 获取永久缓存
export function get(key) {
    const json = window.localStorage.getItem(key);
    return JSON.parse(json);
}
// 移除永久缓存
export function remove(key) {
    window.localStorage.removeItem(key);
}
// 移除全部永久缓存
export function clear() {
    window.localStorage.clear();
}